module.exports = __webpack_public_path__ + "static/img/21.e5a6956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/21.png
// module id = t6uT
// module chunks = 2